import { combineReducers } from 'redux'
import {
    KONTRAK_GET_SUCCESS, KONTRAK_GET_MODAL, LIST_TRAYEK_GET_SUCCESS,
    ADD_KONTRAK_GET_SUCCESS, KONTRAK_EDIT, KONTRAK_DELETE,
    ADENDUM, ADENDUM_GET_SUCCESS
} from '../actions/constant'

const kontrak = (state = [], action) => {
    switch (action.type) {
        case KONTRAK_GET_SUCCESS:
            return action.val
        default:
            return state
    }
}

const adendumFetchAll = (state = { isload: false, data: [] }, action) => {
    switch (action.type) {
        case ADENDUM_GET_SUCCESS:
            return { isload: action.load, data: action.val }
        default:
            return state
    }
}

const addkontrak = (state = { type: '', load: false, addKontrak: null }, action) => {
    switch (action.type) {
        case ADD_KONTRAK_GET_SUCCESS:
            return action
        default:
            return state
    }
}

const editdata = (state = false, action) => {
    switch (action.type) {
        case KONTRAK_EDIT:
            return action.val
        default:
            return state
    }
}

const deletedata = (state = false, action) => {
    switch (action.type) {
        case KONTRAK_DELETE:
            return action.val
        default:
            return state
    }
}

const adendumdata = (state = false, action) => {
    switch (action.type) {
        case ADENDUM:
            return action.val
        default:
            return state
    }
}

const modalbool = (state = false, action) => {
    switch (action.type) {
        case KONTRAK_GET_MODAL:
            return action.val
        default:
            return state
    }
}

const listtrayek = (state = [], action) => {
    switch (action.type) {
        case LIST_TRAYEK_GET_SUCCESS:
            return action.val
        default:
            return state
    }
}

const loadTable = (state = [], action) => {
    switch (action.type) {
        case KONTRAK_GET_SUCCESS:
            return action.load
        default:
            return state
    }
}

const kontrakReducer = combineReducers({
    kontrak,
    loadTable,
    modalbool,
    listtrayek,
    addkontrak,
    editdata,
    deletedata,
    adendumdata,
    adendumFetchAll
})

export default kontrakReducer